import React from "react";


function Solution() {
    return(
        <div style={{position: "relative", width: "80vw", marginLeft: "auto", marginRight: "auto", marginTop: "10rem"}}>
            <div style={{position: "relative", width: "70vw", marginLeft: "auto", marginRight: "auto"}}>
                <span className='display-large h1' >
                    Solution
                </span>
                <span className='headline-large neutrals' style={{marginTop: "1rem"}} >
                    To solve these problems, we have designed a new feature for Albatross called ‘Forms’ that tackles all the issues above. The feature:
                </span>

                <div style={{display: "flex", columnGap: "12px", marginTop: "1rem"}}>
                    <img src="https://ik.imagekit.io/poonr2gma/star.png?updatedAt=1681181592077" style={{width: "24px", height: "24px", marginTop: "0.3rem"}}/>
                    <span>Enables managers to create, maintain, and modify form templates on Albatross and effortlessly designate forms that can automatically attach to newly created process steps or events, based on predefined templates. </span>
                </div>

                <div style={{display: "flex", columnGap: "12px", marginTop: "1rem"}}>
                    <img src="https://ik.imagekit.io/poonr2gma/star.png?updatedAt=1681181592077" style={{width: "24px", height: "24px", marginTop: "0.3rem"}}/>
                    <span>Empowers office and field employees to conveniently review and edit forms within the project on Albatross, eliminating the need to switch to SiteCapture. </span>
                </div>
            </div>
            

            <img src="https://ik.imagekit.io/poonr2gma/Frame%20427322053-min.png?updatedAt=1696212826947" style={{width: "80vw", aspectRatio: "1208/540", marginTop: "3rem"}}/>
            <img src="https://ik.imagekit.io/poonr2gma/Frame%20427322051-min%20(2).png?updatedAt=1696213229538" style={{width: "80vw", aspectRatio: "1208/760", marginTop: "3rem"}}/>
            <img src="https://ik.imagekit.io/poonr2gma/Frame%20427322054-min.png?updatedAt=1695524923048" style={{width: "80vw", aspectRatio: "1208/540", marginTop: "3rem"}}/>
        </div>
        
        
    )
}

export default Solution;
